<template>
    <i class="pi pi-bars text-color text-2xl in-aria-expanded:hidden!" aria-hidden="true" />
    <i class="pi pi-times text-color text-2xl hidden! in-aria-expanded:block!" aria-hidden="true" />
</template>
